import { connect } from 'react-redux'
import permissionGroupSelector from './permissionGroupSelector'
import { sagaActions } from '../../../../sagas'
import PermissionGroup from './PermissionGroup'

export default connect(
  permissionGroupSelector,
  {
    requestRemoveUserFromLayout: sagaActions.requestRemoveUserFromLayout,
    requestSetUserGroupPermissionInHomeLayout: sagaActions.requestSetUserGroupPermissionInHomeLayout,
  }
)(PermissionGroup)
